// import React, { useState } from 'react';
// import {
//   Box,
//   List,
//   ListItemButton,
//   Tooltip,
//   Typography,
//   Paper,
//   Divider,
// } from '@mui/material';

// import { useNavigate, useLocation } from 'react-router-dom';

// // Icons
// import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
// import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
// import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
// import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
// import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'; // Reports
// import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
// import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
// import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
// import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
// import TrackChangesOutlinedIcon from '@mui/icons-material/TrackChangesOutlined';
// import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
// import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
// import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
// import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

// import CRMLogo from '../assets/crmimg.png';

// const Sidebar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
  
//   const [openMaster, setOpenMaster] = useState(false);

//   // 1. Get User Data
//   const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
//   const userRole = userData.role; 

//   // 2. Menu Items List
//   const menuItems = [
//     { id: 'Dashboard', icon: <GridViewOutlinedIcon />, path: '/dashboard' },
//     { id: 'Inquiry Form', icon: <PostAddOutlinedIcon />, path: '/inquiry' },
//     { id: 'Inquiry Details', icon: <ReceiptLongOutlinedIcon />, path: '/inquiry-details' },
//     { id: 'Leads', icon: <GroupsOutlinedIcon />, path: '/leads' },
//     { id: 'Reports', icon: <AssessmentOutlinedIcon />, path: '/reports' }, // Added Reports
//   ];

//   // 3. Master Menus (Admin Only)
//   const masterMenus = [
//    { id: 'Area Master', icon: <LocationOnIcon />, path: '/area-details' },
//     { id: 'Budget Master', icon: <SourceOutlinedIcon />, path: '/budget-details' },
//     { id: 'Communication Master', icon: <CategoryOutlinedIcon />, path: '/communication-details' },
//     { id: 'Customer Master', icon: <PeopleAltOutlinedIcon />, path: '/customer-details' },
//     { id: 'Employee Master', icon: <BadgeOutlinedIcon />, path: '/employee-details' },
//     { id: 'PrimaryGoal Master', icon: <TrackChangesOutlinedIcon />, path: '/PrimaryGoal-details' },
//     { id: 'PropertyType Master', icon: <ApartmentOutlinedIcon />, path: '/PropertyType-details' },
//     { id: 'Source Master', icon: <CampaignOutlinedIcon />, path: '/Source-details' },
//     { id: 'Timeline Master', icon: <AccessTimeOutlinedIcon />, path: '/Timeline-details' },
//   ];

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate('/');
//   };

//   return (
//     <Box
//       sx={{
//         width: '100%', zIndex: 1400, bgcolor: '#ffffff', height: '100vh',
//         display: 'flex', flexDirection: 'column', alignItems: 'center',
//         py: 3, boxShadow: '4px 0px 15px rgba(0, 0, 0, 0.05)',
//         position: 'relative', overflow: 'visible',
//       }}
//     >
//       <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
//         {/* LOGO */}
//         <Box
//           sx={{
//             mb: 5, cursor: 'pointer', transition: '0.3s',
//             '&:hover': { transform: 'rotate(-5deg) scale(1.1)' },
//           }}
//           onClick={() => { navigate('/dashboard'); setOpenMaster(false); }}
//         >
//           <img src={CRMLogo} alt="CRM Logo" style={{ width: 45, height: 'auto' }} />
//         </Box>

//         {/* MENU LIST */}
//         <List sx={{ width: '100%', px: 1 }}>
//           {menuItems.map((item) => {
//             // ROLE LOGIC: Hide Reports for Employees (Role != 1)
//             if (item.id === 'Reports' && userRole !== 1) return null;

//             const isActive = location.pathname === item.path;
//             return (
//               <Tooltip title={item.id} placement="right" key={item.id} arrow>
//                 <ListItemButton
//                   onClick={() => {
//                     navigate(item.path);
//                     setOpenMaster(false);
//                   }}
//                   sx={{
//                     mb: 2, mx: 'auto', borderRadius: '12px', width: 50, height: 50,
//                     justifyContent: 'center',
//                     color: isActive ? '#e65100' : '#64748B',
//                     bgcolor: isActive ? 'rgba(230, 81, 0, 0.08)' : 'transparent',
//                     transition: 'all 0.3s ease',
//                     '&:hover': { bgcolor: 'rgba(230, 81, 0, 0.04)', color: '#e65100' },
//                     '&::before': isActive ? {
//                       content: '""', position: 'absolute', left: -8, height: '24px',
//                       width: '4px', bgcolor: '#e65100', borderRadius: '0 4px 4px 0',
//                     } : {},
//                   }}
//                 >
//                   {React.cloneElement(item.icon, { sx: { fontSize: 24 } })}
//                 </ListItemButton>
//               </Tooltip>
//             );
//           })}

//           {/* MASTER BUTTON - Admin Only */}
//           {userRole === 1 && (
//             <Tooltip title="Master" placement="right" arrow>
//               <ListItemButton
//                 onClick={() => setOpenMaster(!openMaster)}
//                 sx={{
//                   mb: 2, mx: 'auto', borderRadius: '12px', width: 50, height: 50,
//                   justifyContent: 'center',
//                   color: openMaster ? '#e65100' : '#64748B',
//                   bgcolor: openMaster ? 'rgba(230, 81, 0, 0.08)' : 'transparent',
//                   transition: 'all 0.3s ease',
//                   '&:hover': { bgcolor: 'rgba(230, 81, 0, 0.04)', color: '#e65100' },
//                 }}
//               >
//                 <LayersOutlinedIcon sx={{ fontSize: 24 }} />
//               </ListItemButton>
//             </Tooltip>
//           )}

//           <Divider sx={{ my: 2, mx: 1, bgcolor: '#f1f5f9' }} />

//           {/* LOGOUT BUTTON - Adjusted Position */}
//           <Tooltip title="Logout" placement="right" arrow>
//             <ListItemButton
//               onClick={handleLogout}
//               sx={{
//                 mx: 'auto', borderRadius: '12px', width: 50, height: 50,
//                 justifyContent: 'center',
//                 color: '#d32f2f',
//                 transition: 'all 0.3s ease',
//                 '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.08)' },
//               }}
//             >
//               <LogoutOutlinedIcon sx={{ fontSize: 24 }} />
//             </ListItemButton>
//           </Tooltip>
//         </List>
//       </Box>

//       {/* SUB-SIDEBAR (Admin Only) */}
//       {userRole === 1 && openMaster && (
//         <Paper
//           elevation={0}
//           sx={{
//             position: 'absolute', top: 0, left: 65, width: 220, height: '100vh',
//             bgcolor: '#f2f4f7', borderLeft: '1px solid #E2E8F0',
//             boxShadow: '8px 0px 25px rgba(0,0,0,0.06)', zIndex: 1300,
//             borderRadius: 0, display: 'flex', flexDirection: 'column', py: 3, overflowY: 'auto',
//           }}
//         >
//           <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#072a7c', px: 3, mb: 4, mt: 1 }}>
//             Master Menu
//           </Typography>

//           <Box sx={{ px: 2 }}>
//             {masterMenus.map((item) => {
//               const isActive = location.pathname === item.path;
//               return (
//                 <ListItemButton
//                   key={item.id}
//                   onClick={() => {
//                     navigate(item.path);
//                     setOpenMaster(false); // Auto-hide after click
//                   }}
//                   sx={{
//                     height: 50, borderRadius: '12px', mb: 1, px: 2, display: 'flex', alignItems: 'center',
//                     color: isActive ? '#e65100' : '#475569',
//                     bgcolor: isActive ? 'rgba(230,81,0,0.08)' : 'transparent',
//                     transition: 'all 0.3s ease',
//                     '&:hover': { bgcolor: 'rgba(230,81,0,0.05)', color: '#e65100' },
//                   }}
//                 >
//                   {React.cloneElement(item.icon, { sx: { fontSize: 22 } })}
//                   <Typography sx={{ ml: 2, fontSize: '14px', fontWeight: 600 }}>
//                     {item.id}
//                   </Typography>
//                 </ListItemButton>
//               );
//             })}
//           </Box>
//         </Paper>
//       )}
//     </Box>
//   );
// };

// export default Sidebar;

import React, { useState } from 'react';
import {
  Box,
  List,
  ListItemButton,
  Tooltip,
  Typography,
  Paper,
  Divider,
} from '@mui/material';

import { useNavigate, useLocation } from 'react-router-dom';

// Icons
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import TrackChangesOutlinedIcon from '@mui/icons-material/TrackChangesOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';

import CRMLogo from '../assets/crmimg.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openMaster, setOpenMaster]   = useState(false);
  const [openReports, setOpenReports] = useState(false);

  const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
  const userRole = userData.role;

  const menuItems = [
    { id: 'Dashboard',       icon: <GridViewOutlinedIcon />,     path: '/dashboard' },
    { id: 'Inquiry Form',    icon: <PostAddOutlinedIcon />,       path: '/inquiry' },
    { id: 'Inquiry Details', icon: <ReceiptLongOutlinedIcon />,   path: '/inquiry-details' },
    { id: 'Leads',           icon: <GroupsOutlinedIcon />,        path: '/leads' },
    { id: 'Reports',         icon: <AssessmentOutlinedIcon />,    path: null }, 
  ];

  const masterMenus = [
    { id: 'Area Master',          icon: <LocationOnIcon />,           path: '/area-details' },
    { id: 'Budget Master',        icon: <SourceOutlinedIcon />,       path: '/budget-details' },
    { id: 'Communication Master', icon: <CategoryOutlinedIcon />,     path: '/communication-details' },
    { id: 'Customer Master',      icon: <PeopleAltOutlinedIcon />,    path: '/customer-details' },
    { id: 'Employee Master',      icon: <BadgeOutlinedIcon />,        path: '/employee-details' },
    { id: 'PrimaryGoal Master',   icon: <TrackChangesOutlinedIcon />, path: '/PrimaryGoal-details' },
    { id: 'PropertyType Master',  icon: <ApartmentOutlinedIcon />,    path: '/PropertyType-details' },
    { id: 'Source Master',        icon: <CampaignOutlinedIcon />,     path: '/Source-details' },
    { id: 'Timeline Master',      icon: <AccessTimeOutlinedIcon />,   path: '/Timeline-details' },
  ];

  const reportMenus = [
    { id: 'Enquiry Report',  icon: <ArticleOutlinedIcon />,    path: '/enquiry-report' },
    { id: 'Followup Report', icon: <EventNoteOutlinedIcon />,  path: '/followup-report' },
  ];

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const isReportsActive = reportMenus.some((r) => location.pathname === r.path);

  return (
    <Box
      sx={{
        width: '100%', zIndex: 1400, bgcolor: '#ffffff', height: '100vh',
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        py: 3, boxShadow: '4px 0px 15px rgba(0, 0, 0, 0.05)',
        position: 'relative', overflow: 'visible',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>

        {/* LOGO */}
        <Box
          sx={{
            mb: 5, cursor: 'pointer', transition: '0.3s',
            '&:hover': { transform: 'rotate(-5deg) scale(1.1)' },
          }}
          onClick={() => { navigate('/dashboard'); setOpenMaster(false); setOpenReports(false); }}
        >
          <img src={CRMLogo} alt="CRM Logo" style={{ width: 45, height: 'auto' }} />
        </Box>

        {/* MENU LIST */}
        <List sx={{ width: '100%', px: 1 }}>
          {menuItems.map((item) => {

            // Hide Reports for non-admin
            if (item.id === 'Reports' && userRole !== 1) return null;

            // Reports — toggle sub-sidebar
            if (item.id === 'Reports') {
              const isActive = openReports || isReportsActive;
              return (
                <Tooltip title="Reports" placement="right" key="Reports" arrow>
                  <ListItemButton
                    onClick={() => {
                      setOpenReports((p) => !p);
                      setOpenMaster(false);
                    }}
                    sx={{
                      mb: 2, mx: 'auto', borderRadius: '12px', width: 50, height: 50,
                      justifyContent: 'center',
                      color: isActive ? '#e65100' : '#64748B',
                      bgcolor: isActive ? 'rgba(230, 81, 0, 0.08)' : 'transparent',
                      transition: 'all 0.3s ease',
                      '&:hover': { bgcolor: 'rgba(230, 81, 0, 0.04)', color: '#e65100' },
                      '&::before': isActive ? {
                        content: '""', position: 'absolute', left: -8, height: '24px',
                        width: '4px', bgcolor: '#e65100', borderRadius: '0 4px 4px 0',
                      } : {},
                    }}
                  >
                    <AssessmentOutlinedIcon sx={{ fontSize: 24 }} />
                  </ListItemButton>
                </Tooltip>
              );
            }

            // Normal menu items
            const isActive = location.pathname === item.path;
            return (
              <Tooltip title={item.id} placement="right" key={item.id} arrow>
                <ListItemButton
                  onClick={() => {
                    navigate(item.path);
                    setOpenMaster(false);
                    setOpenReports(false);
                  }}
                  sx={{
                    mb: 2, mx: 'auto', borderRadius: '12px', width: 50, height: 50,
                    justifyContent: 'center',
                    color: isActive ? '#e65100' : '#64748B',
                    bgcolor: isActive ? 'rgba(230, 81, 0, 0.08)' : 'transparent',
                    transition: 'all 0.3s ease',
                    '&:hover': { bgcolor: 'rgba(230, 81, 0, 0.04)', color: '#e65100' },
                    '&::before': isActive ? {
                      content: '""', position: 'absolute', left: -8, height: '24px',
                      width: '4px', bgcolor: '#e65100', borderRadius: '0 4px 4px 0',
                    } : {},
                  }}
                >
                  {React.cloneElement(item.icon, { sx: { fontSize: 24 } })}
                </ListItemButton>
              </Tooltip>
            );
          })}

          {/* MASTER BUTTON - Admin Only */}
          {userRole === 1 && (
            <Tooltip title="Master" placement="right" arrow>
              <ListItemButton
                onClick={() => { setOpenMaster((p) => !p); setOpenReports(false); }}
                sx={{
                  mb: 2, mx: 'auto', borderRadius: '12px', width: 50, height: 50,
                  justifyContent: 'center',
                  color: openMaster ? '#e65100' : '#64748B',
                  bgcolor: openMaster ? 'rgba(230, 81, 0, 0.08)' : 'transparent',
                  transition: 'all 0.3s ease',
                  '&:hover': { bgcolor: 'rgba(230, 81, 0, 0.04)', color: '#e65100' },
                }}
              >
                <LayersOutlinedIcon sx={{ fontSize: 24 }} />
              </ListItemButton>
            </Tooltip>
          )}

          <Divider sx={{ my: 2, mx: 1, bgcolor: '#f1f5f9' }} />

          {/* LOGOUT */}
          <Tooltip title="Logout" placement="right" arrow>
            <ListItemButton
              onClick={handleLogout}
              sx={{
                mx: 'auto', borderRadius: '12px', width: 50, height: 50,
                justifyContent: 'center',
                color: '#d32f2f',
                transition: 'all 0.3s ease',
                '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.08)' },
              }}
            >
              <LogoutOutlinedIcon sx={{ fontSize: 24 }} />
            </ListItemButton>
          </Tooltip>
        </List>
      </Box>

      {/* REPORTS SUB-SIDEBAR */}
      {userRole === 1 && openReports && (
        <Paper
          elevation={0}
          sx={{
            position: 'absolute', top: 0, left: 65, width: 220, height: '100vh',
            bgcolor: '#f2f4f7', borderLeft: '1px solid #E2E8F0',
            boxShadow: '8px 0px 25px rgba(0,0,0,0.06)', zIndex: 1300,
            borderRadius: 0, display: 'flex', flexDirection: 'column', py: 3, overflowY: 'auto',
          }}
        >
          <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#072a7c', px: 3, mb: 4, mt: 1 }}>
            Reports
          </Typography>

          <Box sx={{ px: 2 }}>
            {reportMenus.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <ListItemButton
                  key={item.id}
                  onClick={() => {
                    navigate(item.path);
                    setOpenReports(false);
                  }}
                  sx={{
                    height: 50, borderRadius: '12px', mb: 1, px: 2,
                    display: 'flex', alignItems: 'center',
                    color: isActive ? '#e65100' : '#475569',
                    bgcolor: isActive ? 'rgba(230,81,0,0.08)' : 'transparent',
                    transition: 'all 0.3s ease',
                    '&:hover': { bgcolor: 'rgba(230,81,0,0.05)', color: '#e65100' },
                  }}
                >
                  {React.cloneElement(item.icon, { sx: { fontSize: 22 } })}
                  <Typography sx={{ ml: 2, fontSize: '14px', fontWeight: 600 }}>
                    {item.id}
                  </Typography>
                </ListItemButton>
              );
            })}
          </Box>
        </Paper>
      )}

      {/* MASTER SUB-SIDEBAR - Admin Only */}
      {userRole === 1 && openMaster && (
        <Paper
          elevation={0}
          sx={{
            position: 'absolute', top: 0, left: 65, width: 220, height: '100vh',
            bgcolor: '#f2f4f7', borderLeft: '1px solid #E2E8F0',
            boxShadow: '8px 0px 25px rgba(0,0,0,0.06)', zIndex: 1300,
            borderRadius: 0, display: 'flex', flexDirection: 'column', py: 3, overflowY: 'auto',
          }}
        >
          <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#072a7c', px: 3, mb: 4, mt: 1 }}>
            Master Menu
          </Typography>

          <Box sx={{ px: 2 }}>
            {masterMenus.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <ListItemButton
                  key={item.id}
                  onClick={() => {
                    navigate(item.path);
                    setOpenMaster(false);
                  }}
                  sx={{
                    height: 50, borderRadius: '12px', mb: 1, px: 2,
                    display: 'flex', alignItems: 'center',
                    color: isActive ? '#e65100' : '#475569',
                    bgcolor: isActive ? 'rgba(230,81,0,0.08)' : 'transparent',
                    transition: 'all 0.3s ease',
                    '&:hover': { bgcolor: 'rgba(230,81,0,0.05)', color: '#e65100' },
                  }}
                >
                  {React.cloneElement(item.icon, { sx: { fontSize: 22 } })}
                  <Typography sx={{ ml: 2, fontSize: '14px', fontWeight: 600 }}>
                    {item.id}
                  </Typography>
                </ListItemButton>
              );
            })}
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default Sidebar;